export default __webpack_public_path__ + "guide--vector-tiles-standards-wo-5-480-f042102fa67f4b936c062e3b22995dd7.webp";